// extracted by mini-css-extract-plugin
export default {"dropdown":"DashboardNavDropdown_dropdown__+UPhn","header":"DashboardNavDropdown_header__yfcDB"};